export const getGeneralMessage = (state:any) => state.general.message;